import React from 'react';
import { cn } from '@/utils/cn';
import { formatCurrency } from '@/utils/format';
import { ActionMenu } from '@/components/ui/ActionMenu';
import { TablePagination } from '@/components/ui/TablePagination';
import { CardList } from '@/components/ui/CardList';

export function ProjectEquipmentList({ equipment }: { equipment: any[] }) {
  return (
    <div className="bg-white rounded-md border border-slate-100  overflow-hidden">
      <div className="p-4 border-b border-slate-50">
        <h3 className="text-sm font-normal text-slate-900">Danh sách thiết bị ({equipment.length})</h3>
      </div>

      {/* Desktop Table */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-slate-50/50 text-xs font-normal text-slate-400 border-b border-slate-100">
              <th className="py-3 px-4 w-10 font-normal">#</th>
              <th className="py-3 px-4 font-normal">Tên thiết bị</th>
              <th className="py-3 px-4 font-normal">Loại thiết bị</th>
              <th className="py-3 px-4 font-normal">Tình trạng</th>
              <th className="py-3 px-4 text-center font-normal">Hiệu suất</th>
              <th className="py-3 px-4 text-right font-normal">Giá trị (VND)</th>
              <th className="py-3 px-4 w-10 text-center font-normal">Hành động</th>
            </tr>
          </thead>
          <tbody className="text-xs lg:text-sm divide-y divide-slate-50">
            {equipment.map((e) => (
              <tr key={e.id} className="hover:bg-slate-50/50 transition-colors group">
                <td className="py-4 px-4 text-slate-400 font-normal">{e.index}</td>
                <td className="py-4 px-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-md bg-slate-50 p-1 flex items-center justify-center shrink-0 border border-slate-100 group-hover:border-emerald-200 transition-all">
                       <img src={e.image} alt="" className="max-w-full max-h-full object-contain" />
                    </div>
                    <div className="flex flex-col min-w-0">
                       <span className="font-normal text-slate-700 truncate group-hover:text-emerald-600 transition-colors cursor-pointer">{e.name}</span>
                    </div>
                  </div>
                </td>
                <td className="py-4 px-4">
                   <span className="text-xs font-normal text-blue-600 bg-blue-50 px-2 py-0.5 rounded-md">{e.type}</span>
                </td>
                <td className="py-4 px-4">
                   <span className={cn("px-2 py-0.5 rounded-md text-xs font-normal whitespace-nowrap", e.statusColor)}>{e.status}</span>
                </td>
                <td className="py-4 px-4 text-center font-normal text-slate-700">{e.utilization}%</td>
                <td className="py-4 px-4 text-right font-normal text-slate-700">{formatCurrency(e.value, '')}</td>
                <td className="py-4 px-4 text-center">
                   <ActionMenu items={[{ label: 'Chi tiết thiết bị' }, { label: 'Lịch sử bảo dưỡng' }, { label: 'Sửa chữa' }, { label: 'Xóa', destructive: true }]} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Card List */}
      <div className="lg:hidden p-4">
        <CardList 
          items={equipment}
          renderCard={(e) => (
            <div key={e.id} className="bg-white p-3 rounded-md border border-slate-100 space-y-4">
              <div className="flex justify-between items-start">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-md bg-slate-50 p-2 border border-slate-100">
                    <img src={e.image} alt="" className="w-full h-full object-contain" />
                  </div>
                  <div className="space-y-0.5 min-w-0">
                    <h4 className="text-xs font-normal text-slate-900">{e.name}</h4>
                    <p className="text-xs font-normal text-slate-400">{e.code}</p>
                  </div>
                </div>
                <ActionMenu items={[{ label: 'Chi tiết' }, { label: 'Bảo dưỡng' }, { label: 'Sửa chữa' }]} />
              </div>
              <div className="grid grid-cols-2 gap-4 border-t border-slate-50 pt-3 text-xs">
                 <div className="space-y-1">
                    <p className="text-slate-400 font-normal">Hiệu suất</p>
                    <p className="font-normal text-slate-900">{e.utilization}%</p>
                 </div>
                 <div className="space-y-1 text-right">
                    <p className="text-slate-400 font-normal">Giá trị</p>
                    <p className="font-normal text-slate-900">{formatCurrency(e.value, '')}</p>
                 </div>
              </div>
              <div className="flex justify-between items-center bg-slate-50/50 p-2 rounded-md">
                 <span className="text-xs font-normal text-slate-500">{e.location}</span>
                 <span className={cn("px-2 py-0.5 rounded-md text-xs font-normal", e.statusColor)}>{e.status}</span>
              </div>
            </div>
          )}
        />
      </div>

      <div className="px-4 border-t border-slate-50 bg-slate-50/30">
        <TablePagination currentPage={1} totalItems={48} pageSize={10} onPageChange={() => {}} itemLabel="thiết bị" />
      </div>
    </div>
  );
}
